export default __webpack_public_path__ + "static/media/airtel.bd898229.svg";